import { Colors } from "./en/Colors";
import { detections } from "./en/Detections";
import { Errors } from "./en/Errors";
import { ForensicReconstruction } from "./en/ForensicReconstruction";
import { LicensePlatesSearch } from "./en/LicensePlatesSearch";
import { Status } from "./en/Status";
import { Storylines } from "./en/Storylines";
import { GranularityDashboard } from "./en/GranularityDashboard";
import { CountReport } from "./en/CountReport";
import { DetectionsHistory } from "./en/DetectionsHistory";
import { countries } from "./en/Countries";
import { OperabilitySummary } from "./en/OperabilitySummary";
import { BulkAssetsConfig } from "./en/BulkAssetsConfig";
import { Realtime } from "./en/Realtime";
import { RoundsReport } from "./en/RoundsReport";
import { Applications } from "./en/Applications";
import { AccessControlReport } from "./en/AccessControlReport";
import { ImageReport } from "./en/ImageReport";
import { Tools } from "./en/Tools";
import { FaceDatabase } from "./en/FaceDatabase";
import { FaceDetectionsSearch } from "./en/FaceDetectionsSearch";

const en = {
  general: {
    from: "From",
    to: "To",
    accuracy: "Accuracy",
    add: "Add",
    addedMP: "Added",
    additionalInformation: "Additional information",
    address: "Address",
    alert: "Alert",
    allFP: "All",
    and: "and",
    applyChanges: "Apply changes",
    applyFilters: "Apply filters",
    attachFiles: "Attach Files",
    attachments: "Attachments",
    author: "Author",
    camera: "Camera",
    cameraP: "Cameras",
    cancel: "Cancel",
    category: "Category",
    centre: "Centre",
    characters: "Characters",
    checkAll: "Check all",
    classes: "Classes",
    clearFilters: "Clear filters",
    clearSearch: "Clear search",
    close: "Close",
    copyToClipboard: "Copy to clipboard",
    create: "Create",
    creationDate: "Creation date",
    customF: "Custom",
    date: "Date",
    debuggingMode: "Debugging mode",
    default: "Default",
    detections: "Detections",
    delete: "Delete",
    deletedMP: "Deleted",
    description: "Description",
    deselect: "Deselect",
    download: "Download",
    downloadFile: "Download file",
    downloadImage: "Download image",
    downloadImages: "Download images",
    downloadRawData: "Download raw data",
    edit: "Edit",
    editMode: "Edit mode",
    endDate: "End date",
    elements: "Elements",
    example: "Example",
    exportAsPDF: "Export as PDF",
    filter: "Filter",
    goBack: "Go back",
    goToSettings: "Go to Setting",
    height: "Height",
    hide: "Hide",
    hideLabels: "Hide labels",
    images: "Images",
    languages: {
      english: "English",
      spanish: "Spanish",
    },
    length: "Length",
    load: "Load",
    loading: "Loading",
    location: "Location",
    login: "Login",
    maximum: "Máximum",
    minimum: "Minimum",
    month: "Month",
    name: "Name",
    next: "Next",
    notAuthenticated: "Authentication required",
    of: "of",
    operation: "Operation",
    panicButton: "Panic button",
    panicButtonActivated: "Panic button activated",
    panicButtonPressed: (buttonCode: string) =>
      `Panic button ${buttonCode} activated`,
    preview: "Preview",
    previous: "Previous",
    probability: "Probability",
    recommended: "Recommended",
    report: "Report",
    required: "Required",
    reset: "Reset",
    results: "Results",
    reload: "Reload",
    save: "Save",
    saveChanges: "Save changes",
    search: "Search",
    searchNoun: "Search",
    seeAttachments: "See attachments",
    seeChanges: "See changes",
    seeContent: "See content",
    seeSelectedImages: "See selected images",
    seeDetails: "See details",
    select: "Select",
    selectedImages: "Selected images",
    selectCategory: "Select category",
    selected_LC_F: "selected",
    selected_LC_M: "selected",
    selectLocation: "Select location",
    settings: "Settings",
    show: "Show",
    showLabels: "Show labels",
    sort: "Sort",
    startDate: "Start date",
    status: "Status",
    summary: "Summary",
    surname: "Surname",
    switchToDarkTheme: "Switch to dark theme",
    switchToLightTheme: "Switch to light theme",
    time: "Time",
    timeInterval: "Time interval",
    type: "Type",
    user: "User",
    username: "Username",
    userP: "Users",
    videos: "Videos",
    viewAttachedVideo: "View attached video",
    viewAttachedImage: "View attached image",
    yes: "Yes",
    Messages: {
      browseOrDropFilesToUpload: "Browse or drag and drop files to upload.",
      fileSizeMayNotExceed: "Total file size may not exceed",
      fileSizeExceeded: "File size exceeded.",
      addABriefDescription: "Add a brief description",
      noResultsFound: "No results found",
      noElementsFound: "No elements found.",
      noDetections: "No detections.",
      noSelectedElements: "No selected elements.",
      weAreAboutToRedirectYouTo: "We're about to redirect you to",
      doYouWishToContinue: "Do you wish to continue?",
      error404: "Sorry, the page you visited does not exist.",
      notAuthorised: "Sorry, you are not authorised to access this page.",
      thisViewIsNotYetAvailableOnMobile:
        "This view is not yet available on mobile",
      viewItOnDesktopInstead: "View it on desktop instead",
      noBlankSpacesOrSpecialCharactersAllowed:
        "No blank spaces or special characters allowed.",
      lastUpdatedAt: "Last updated at",
      pinCurrentDetection: "Pin current detection",
      unpinCurrentDetection: "Unpin current detection",
    },
    pageCount: (total: number, range: [number, number]) =>
      `${range[0]}-${range[1]} of ${total} items`,
    Errors: Errors,
  },
  ForensicReconstruction: ForensicReconstruction,
  Storylines: Storylines,
  LicensePlatesSearch: LicensePlatesSearch,
  GranularityDashboard: GranularityDashboard,
  CountReport: CountReport,
  DetectionsHistory: DetectionsHistory,
  OperabilitySummary: OperabilitySummary,
  BulkAssetsConfig: BulkAssetsConfig,
  Realtime: Realtime,
  RoundsReport: RoundsReport,
  Applications: Applications,
  AccessControlReport: AccessControlReport,
  ImageReport: ImageReport,
  detections: detections,
  status: Status,
  colors: Colors,
  countries: countries,
  Tools,
  FaceDatabase,
  FaceDetectionsSearch,
};

export default en;
